(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Compteur-entre-Soldes"] && !Shopify.designMode) return;
  try {
    
const padCountdownValue=value=>String(value).padStart(2,'0');const updatePromotionCountdown=countdown=>{const end=new Date(countdown.dataset.countdownEnd).getTime();const distance=end-Date.now();const ended=countdown.parentElement.querySelector('[data-countdown-ended]');if(Number.isNaN(end))return;if(distance<=0){countdown.hidden=true;ended.hidden=false;ended.textContent=countdown.dataset.endedText;return}countdown.hidden=false;ended.hidden=true;countdown.querySelector('[data-countdown-days]').textContent=padCountdownValue(Math.floor(distance/86400000));countdown.querySelector('[data-countdown-hours]').textContent=padCountdownValue(Math.floor(distance%86400000/3600000));countdown.querySelector('[data-countdown-minutes]').textContent=padCountdownValue(Math.floor(distance%3600000/60000));countdown.querySelector('[data-countdown-seconds]').textContent=padCountdownValue(Math.floor(distance%60000/1000))};const refreshPromotionCountdowns=()=>{document.querySelectorAll('[data-promotion-countdown]').forEach(updatePromotionCountdown)};refreshPromotionCountdowns();setInterval(refreshPromotionCountdowns,1000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Hero-pour-Soldes"] && !Shopify.designMode) return;
  try {
    
const updateCountdowns=()=>{document.querySelectorAll('[data-countdown]').forEach(countdown=>{const value=countdown.querySelector('[data-countdown-value]');const end=new Date(countdown.dataset.countdown).getTime();const distance=end-Date.now();if(!value||Number.isNaN(end))return;if(distance<=0){value.textContent=countdown.dataset.endedText;return}const days=Math.floor(distance/86400000);const hours=Math.floor(distance%86400000/3600000);const minutes=Math.floor(distance%3600000/60000);const seconds=Math.floor(distance%60000/1000);value.textContent=`${days}j ${hours}h ${minutes}m ${seconds}s`})};updateCountdowns();setInterval(updateCountdowns,1000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordeon"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.querySelector('.faq-accordion-wrapper');
  if (!wrapper) return;
  const items = wrapper.querySelectorAll('.faq-item');
  const toggle = wrapper.querySelector('.faq-toggle-container .faq-toggle-link');
  const limit = 4;

  if (toggle) {
    toggle.addEventListener('click', function() {
      const hidden = Array.from(items).filter((el, i) => i >= limit && el.style.display === 'none');
      const finalBlock = wrapper.querySelector('.faq-final-text');
      if (hidden.length) {
        hidden.forEach(el => el.style.display = 'block');
        toggle.textContent = 'Afficher moins';
        if(finalBlock) finalBlock.style.display = 'block';
      } else {
        items.forEach((el, i) => { if (i >= limit) el.style.display = 'none'; });
        toggle.textContent = 'Afficher plus';
        if(finalBlock) finalBlock.style.display = 'none';
      }
    });
  }

  wrapper.addEventListener('click', function(event) {
    const summary = event.target.closest('summary');
    if (!summary || !wrapper.contains(summary)) return;
    const currentDetail = summary.parentElement;
    wrapper.querySelectorAll('details').forEach(detail => {
      if (detail !== currentDetail && detail.hasAttribute('open')) {
        detail.removeAttribute('open');
      }
    });
  });

  wrapper.addEventListener('keydown', function(event) {
    const summary = event.target.closest('summary');
    if (!summary || (event.key !== 'Enter' && event.key !== ' ')) return;
    const currentDetail = summary.parentElement;
    wrapper.querySelectorAll('details').forEach(detail => {
      if (detail !== currentDetail && detail.hasAttribute('open')) {
        detail.removeAttribute('open');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('responsive-announcement-bar')) {
    class ResponsiveAnnouncementBar extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.dataset.initialized = 'true';
        this.viewport = this.querySelector('[data-announcement-viewport]');
        this.track = this.querySelector('[data-announcement-track]');
        this.group = this.querySelector('[data-announcement-group]');
        this.controls = this.querySelector('[data-announcement-controls]');
        this.previousButton = this.querySelector('[data-announcement-previous]');
        this.nextButton = this.querySelector('[data-announcement-next]');
        this.mediaQuery = window.matchMedia('(max-width: 749px)');
        this.currentSlide = 0;
        this.configurationId = 0;

        if (!this.viewport || !this.track || !this.group) {
          this.dataset.ready = 'true';
          return;
        }

        this.prepareOriginalAnnouncements();
        this.bindEvents();
        this.configureForCurrentScreen();

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => {
            if (this.activeMode !== 'marquee') return;

            cancelAnimationFrame(this.resizeFrame);
            this.resizeFrame = requestAnimationFrame(() => this.setupMarquee());
          });
          this.resizeObserver.observe(this.viewport);
        }
      }

      disconnectedCallback() {
        this.stopRotation();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.resizeFrame);
        cancelAnimationFrame(this.marqueeFrame);

        if (this.mediaQuery?.removeEventListener && this.handleBreakpointChange) {
          this.mediaQuery.removeEventListener('change', this.handleBreakpointChange);
        } else if (this.mediaQuery?.removeListener && this.handleBreakpointChange) {
          this.mediaQuery.removeListener(this.handleBreakpointChange);
        }
      }

      bindEvents() {
        this.handleBreakpointChange = () => this.configureForCurrentScreen();

        if (this.mediaQuery.addEventListener) {
          this.mediaQuery.addEventListener('change', this.handleBreakpointChange);
        } else {
          this.mediaQuery.addListener(this.handleBreakpointChange);
        }

        this.previousButton?.addEventListener('click', () => this.changeSlide(-1));
        this.nextButton?.addEventListener('click', () => this.changeSlide(1));

        this.addEventListener('mouseenter', () => this.pauseForInteraction());
        this.addEventListener('mouseleave', () => this.resumeAfterInteraction());
        this.addEventListener('focusin', () => this.pauseForInteraction());
        this.addEventListener('focusout', () => {
          requestAnimationFrame(() => this.resumeAfterInteraction());
        });
        this.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse') this.pauseForInteraction();
        });
        this.addEventListener('pointerup', (event) => {
          if (event.pointerType !== 'mouse') this.resumeAfterInteraction(true);
        });
        this.addEventListener('pointercancel', () => this.resumeAfterInteraction(true));

        this.addEventListener('shopify:block:select', (event) => {
          if (this.activeMode !== 'rotation') return;

          const selectedItem = this.originalItems.find((item) => item.contains(event.target));
          const selectedIndex = this.originalItems.indexOf(selectedItem);

          if (selectedIndex >= 0) {
            this.showSlide(selectedIndex);
            this.stopRotation();
          }
        });
      }

      prepareOriginalAnnouncements() {
        const slides = Array.from(this.group.children).filter((element) =>
          element.classList.contains('announcement-bar__slide')
        );

        this.originalItems = slides.map((slide) => {
          const item = document.createElement('div');
          item.className = 'announcement-bar-responsive__item';
          item.dataset.announcementOriginal = 'true';
          this.group.insertBefore(item, slide);
          item.appendChild(slide);
          return item;
        });
      }

      getDevicePrefix() {
        return this.mediaQuery.matches ? 'mobile' : 'desktop';
      }

      getDeviceSetting(settingName, fallback = '') {
        const prefix = this.getDevicePrefix();
        const propertyName = `${prefix}${settingName.charAt(0).toUpperCase()}${settingName.slice(1)}`;
        const value = this.dataset[propertyName];

        if (value === undefined || value === null) return fallback;
        if (value === '' && settingName !== 'separator') return fallback;
        return value;
      }

      configureForCurrentScreen() {
        const configurationId = ++this.configurationId;
        const requestedMode = this.getDeviceSetting('mode', 'rotation');
        const supportedModes = ['rotation', 'single_line', 'marquee'];

        this.activeMode = supportedModes.includes(requestedMode) ? requestedMode : 'rotation';
        this.activeSeparator = this.getDeviceSetting('separator', '');
        this.activePauseOnHover = this.getDeviceSetting('pauseOnHover', 'true') === 'true';
        this.activeRotationSpeed = Math.max(
          2,
          Number.parseInt(this.getDeviceSetting('speed', '5'), 10) || 5
        );

        const spacing = Math.max(
          0,
          Number.parseInt(this.getDeviceSetting('spacing', '24'), 10) || 0
        );
        const marqueeDuration = Math.max(
          8,
          Number.parseInt(this.getDeviceSetting('marqueeDuration', '25'), 10) || 25
        );
        const lineDistribution = this.getDeviceSetting('lineDistribution', 'space-between');

        this.style.setProperty('--announcement-item-gap', `${spacing}px`);
        this.style.setProperty('--announcement-marquee-duration', `${marqueeDuration}s`);
        this.style.setProperty('--announcement-line-justify', lineDistribution);
        this.dataset.ready = 'false';
        this.dataset.pauseActive = String(this.activePauseOnHover);

        this.stopRotation();
        this.removeDecorativeContent();
        this.removeSeparators();
        this.hideControls();

        this.classList.remove(
          'announcement-bar-responsive--rotation',
          'announcement-bar-responsive--single-line',
          'announcement-bar-responsive--marquee'
        );
        this.classList.add(`announcement-bar-responsive--${this.activeMode.replace('_', '-')}`);

        this.originalItems.forEach((item) => this.setItemVisibility(item, true));
        this.updateAccessibleLinkLabels();

        if (this.originalItems.length === 0) {
          this.dataset.ready = 'true';
          return;
        }

        if (this.activeMode === 'rotation') {
          this.setupRotation();
          return;
        }

        this.viewport.setAttribute('aria-live', 'off');

        if (this.activeMode === 'single_line') {
          this.addSeparators(false);
          this.dataset.ready = 'true';
          return;
        }

        this.addSeparators(true);
        cancelAnimationFrame(this.marqueeFrame);
        this.marqueeFrame = requestAnimationFrame(() => {
          if (configurationId === this.configurationId) this.setupMarquee();
        });
      }

      updateAccessibleLinkLabels() {
        const prefix = this.getDevicePrefix();

        this.originalItems.forEach((item) => {
          const link = item.querySelector('.announcement-bar__link');
          if (!link) return;

          const label =
            prefix === 'mobile' ? link.dataset.mobileLabel : link.dataset.desktopLabel;

          if (label) link.setAttribute('aria-label', label);
        });
      }

      setItemVisibility(item, isVisible) {
        const slide = item.querySelector('.announcement-bar__slide');
        item.setAttribute('aria-hidden', String(!isVisible));

        if (slide) slide.setAttribute('aria-hidden', String(!isVisible));

        if (isVisible) {
          item.removeAttribute('inert');
        } else {
          item.setAttribute('inert', '');
        }
      }

      setupRotation() {
        this.currentSlide = Math.min(this.currentSlide, this.originalItems.length - 1);
        this.showSlide(this.currentSlide);
        this.viewport.setAttribute('aria-live', this.originalItems.length > 1 ? 'polite' : 'off');

        const showArrows =
          this.getDeviceSetting('showArrows', 'true') === 'true' &&
          this.originalItems.length > 1;

        if (showArrows) this.showControls();

        this.dataset.ready = 'true';
        this.startRotation();
      }

      showSlide(index) {
        if (this.originalItems.length === 0) return;

        this.currentSlide =
          (index + this.originalItems.length) % this.originalItems.length;

        this.originalItems.forEach((item, itemIndex) => {
          this.setItemVisibility(item, itemIndex === this.currentSlide);
        });
      }

      changeSlide(direction) {
        if (this.activeMode !== 'rotation' || this.originalItems.length < 2) return;

        this.showSlide(this.currentSlide + direction);
        this.stopRotation();
        this.startRotation();
      }

      startRotation(ignoreInteraction = false) {
        if (this.activeMode !== 'rotation' || this.originalItems.length < 2) return;
        if (
          !ignoreInteraction &&
          (this.matches(':hover') || this.contains(document.activeElement))
        ) {
          return;
        }

        this.stopRotation();
        this.rotationTimer = window.setInterval(() => {
          this.showSlide(this.currentSlide + 1);
        }, this.activeRotationSpeed * 1000);
      }

      stopRotation() {
        if (!this.rotationTimer) return;
        window.clearInterval(this.rotationTimer);
        this.rotationTimer = null;
      }

      showControls() {
        if (!this.controls) return;
        this.controls.hidden = false;
        this.classList.add('announcement-bar-responsive--with-controls');
      }

      hideControls() {
        if (this.controls) this.controls.hidden = true;
        this.classList.remove('announcement-bar-responsive--with-controls');
      }

      pauseForInteraction() {
        if (this.activeMode === 'rotation') {
          this.stopRotation();
          return;
        }

        if (this.activeMode === 'marquee' && this.activePauseOnHover) {
          this.track.style.animationPlayState = 'paused';
        }
      }

      resumeAfterInteraction(force = false) {
        if (!force && (this.matches(':hover') || this.contains(document.activeElement))) return;

        if (this.activeMode === 'rotation') {
          this.startRotation(force);
          return;
        }

        if (this.activeMode === 'marquee') {
          this.track.style.animationPlayState = '';
        }
      }

      removeSeparators() {
        this.originalItems.forEach((item) => {
          item
            .querySelectorAll(':scope > .announcement-bar-responsive__separator')
            .forEach((separator) => separator.remove());
        });
        this.group.classList.remove('announcement-bar-responsive__group--with-separator');
      }

      addSeparators(includeLastSeparator) {
        if (this.activeSeparator === '') return;

        this.group.classList.add('announcement-bar-responsive__group--with-separator');

        this.originalItems.forEach((item, index) => {
          if (!includeLastSeparator && index === this.originalItems.length - 1) return;

          const separator = document.createElement('span');
          separator.className = 'announcement-bar-responsive__separator';
          separator.setAttribute('aria-hidden', 'true');
          separator.textContent = this.activeSeparator;
          item.appendChild(separator);
        });
      }

      removeDecorativeContent() {
        this.track
          .querySelectorAll('[data-announcement-group-clone]')
          .forEach((clone) => clone.remove());
        this.group
          .querySelectorAll('[data-announcement-filler]')
          .forEach((clone) => clone.remove());
      }

      makeDecorativeClone(element) {
        element.setAttribute('aria-hidden', 'true');
        element.setAttribute('inert', '');

        const cloneElements = [element, ...element.querySelectorAll('*')];

        cloneElements.forEach((cloneElement) => {
          cloneElement.removeAttribute('id');
          cloneElement.removeAttribute('ref');
          cloneElement.removeAttribute('data-shopify-editor-block');
        });

        element.querySelectorAll('.announcement-bar__slide').forEach((slide) => {
          slide.setAttribute('aria-hidden', 'true');
        });

        element
          .querySelectorAll('a, button, input, select, textarea, [tabindex]')
          .forEach((interactiveElement) => interactiveElement.setAttribute('tabindex', '-1'));

        return element;
      }

      setupMarquee() {
        if (this.activeMode !== 'marquee' || !this.viewport.clientWidth) {
          this.dataset.ready = 'true';
          return;
        }

        this.dataset.ready = 'false';
        this.removeDecorativeContent();

        const minimumGroupWidth = this.viewport.clientWidth * 1.15;
        let repetitions = 0;

        while (this.group.scrollWidth < minimumGroupWidth && repetitions < 20) {
          this.originalItems.forEach((item) => {
            const filler = this.makeDecorativeClone(item.cloneNode(true));
            filler.dataset.announcementFiller = 'true';
            this.group.appendChild(filler);
          });
          repetitions += 1;
        }

        const repeatedGroup = this.makeDecorativeClone(this.group.cloneNode(true));
        repeatedGroup.dataset.announcementGroupClone = 'true';
        this.track.appendChild(repeatedGroup);

        const groupWidth = this.group.getBoundingClientRect().width;
        this.style.setProperty('--announcement-marquee-shift', `${groupWidth}px`);

        this.track.style.animation = 'none';
        void this.track.offsetWidth;
        this.track.style.animation = '';
        this.track.style.animationPlayState = '';
        this.dataset.ready = 'true';
      }
    }

    customElements.define('responsive-announcement-bar', ResponsiveAnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
